import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

async function postImageBgRemove(variables: {
  imageKey: string;
}): Promise<AxiosResponse<FetchResult<{ imageS3Url: string }>>> {
  const response = await instance.post(`/ai/background-removal`, variables);
  return response;
}

const usePostImageBgRemove = (
  onSuccess?: (data: AxiosResponse<FetchResult<{ imageS3Url: string }>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { mutateAsync, isPending, data } = useMutation({
    mutationKey: ['post', '/ai/background-removal`'],
    mutationFn: (variables: { imageKey: string }) => postImageBgRemove(variables),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { mutateAsync, isPending, data };
};

export default usePostImageBgRemove;
